import { storeStatusLabel } from '@/lib/store-status';
import type { StoreOrderStatus } from './types';

export const STORE_ORDER_STATUSES: StoreOrderStatus[] = [
    'pending_payment', 'paid', 'processing', 'shipped', 'delivered', 'completed', 'cancelled', 'refunded',
];

export function statusLabel(status: StoreOrderStatus): string {
    return storeStatusLabel(status);
}
